<template>
    <div class="card p-3">
        <div class="card-content">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Agent</th>
                                <th>Statut</th>
                                <th>Catégorie</th>
                                <th>Dernière connexion</th>
                                <th>Nombre de discussions max.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(agent, index) in AllAgents" :key="index + 'agents'">
                                <th scope="row" v-if="agent.first_name || agent.last_name"><router-link :to="{ name: 'agentView', params: {agent: agent, agentID: agent.uuid}}">{{agent.first_name}} {{agent.last_name}}</router-link></th>
                                <th scope="row" v-else><router-link :to="{ name: 'agentView', params: {agent: agent, agentID: agent.uuid}}">{{agent.email}}</router-link></th>
                                <td v-if="agent.paused">En pause</td>
                                <td v-if="agent.connected">En ligne</td>
                                <td v-if="!agent.paused && !agent.connected">Indisponible</td>
                                <td>{{agent.kind}}</td>
                                <td>{{agent.last_login | formatLongDatetime}}</td>
                                <td>{{agent.max_rooms}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    AllAgents () {
      return this.$store.getters.getAllAgents
    }
  }
}
</script>
